import { PropsWithChildren } from "react";

export const SearchResultTitle: React.FC<PropsWithChildren> = ({
  children,
}) => <h3 className="text-md font-bold">{children}</h3>;
